import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import CuentasBancarias from './cuentasBancarias';

const CuentasBancariasIndex = () => {
    const history = useHistory();

    return (
        <div className="w-full p-4 md:p-6">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Cuentas Bancarias</h1>
                <div className="flex space-x-2">
                    <Button
                        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full shadow-md"
                        variant="contained"
                        color="primary"
                        onClick={() => history.push(`/Catalogo/CuentaBancaria`)}
                    >
                        + Nuevo Cuenta Bancaria
                    </Button>
                </div>
            </div>

            <CuentasBancarias />
        </div>
    );
};

export default CuentasBancariasIndex;
